import { writable } from "svelte/store";
export const settings = writable({
    lang: null,
    showElements: {
        productList: {
            gridListToggle: null,
        },
    },
});
